module.exports = locationIdToSubmitProperties

const { locationIdToProperties } = require('./location-id-to-properties')

// This can be removed when the information has somehow been included
// in location docs
function locationIdToSubmitProperties (locationId) {
  const location = locationIdToProperties(locationId)
  switch (location.level) {
    case 'zone':
    case 'national':
    case 'country':
    case 'state':
      return {
        submitsOwnReport: true,
        submitsBatchedCounts: true,
        submitsMultiFieldCounts: false
      }
    case 'sdp':
      return {
        submitsOwnReport: false,
        submitsBatchedCounts: false,
        submitsMultiFieldCounts: true
      }
    default:
      return {
        submitsOwnReport: false,
        submitsBatchedCounts: false,
        submitsMultiFieldCounts: false
      }
  }
}
